import { render, staticRenderFns } from "./Prototype.vue?vue&type=template&id=aedb80bc&scoped=true"
import script from "./Prototype.vue?vue&type=script&lang=js"
export * from "./Prototype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedb80bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/b08365e4-b55a-4269-82b4-b5e5a1490008/workspace/hsylc_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aedb80bc')) {
      api.createRecord('aedb80bc', component.options)
    } else {
      api.reload('aedb80bc', component.options)
    }
    module.hot.accept("./Prototype.vue?vue&type=template&id=aedb80bc&scoped=true", function () {
      api.rerender('aedb80bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/RadioGroup/Prototype.vue"
export default component.exports